import { actionTypes } from '../actions/constants';
import get from 'lodash.get';
const defaultState = {
    items: [],
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case actionTypes.SET_CART_ITEMS:
            return {
                ...state,
                items: get(action, 'payload.items') || [],
            };
        case actionTypes.SET_ADD_CART_ITEM_MUTATION_COMPLETED:
            return {
                ...state,
                addCartItemMutationCompleted: true,
            };
        case actionTypes.REMOVE_PORTFOLIO_CART_ITEM:
            return {
                ...state,
                removedPortfolioCartItemId: get(action, 'payload.itemId') || '',
            };
        default:
            return state;
    }
};
